import fulltextsearchlight from 'full-text-search-light';
import tariffario from '../data/tariffario.json';

var search = new fulltextsearchlight();
search.ignore_case(true);
const tariffe = tariffario[0].ElencoSezioni;

tariffe.map(tariffa => search.add(tariffa));

export { search };
